/* eslint-disable */
import SearchPageModel from "@/js/desktop/Domain/Model/SearchPageModel";

let SearchPageReviewsModel = SearchPageModel.extend({
	filterByRatingByLocation: function (hotels) {
		var filters = this.get('filterCriteria');
		if (filters.get('ratingLocation')) {
			hotels = _.filter(hotels, function (hotel) {
				var details = hotel.get('ratingDetails') ? hotel.get('ratingDetails').hotel : null;
				return (details !== null) ? Math.round(details) >= filters.get('ratingLocation') : false;
			});
		}
		return hotels;
	},
	filterByRatingByService: function (hotels) {
		var filters = this.get('filterCriteria');
		if (filters.get('ratingService')) {
			hotels = _.filter(hotels, function (hotel) {
				var details = hotel.get('ratingDetails') ? hotel.get('ratingDetails').service : null;
				return (details !== null) ? Math.round(details) >= filters.get('ratingService') : false;
			});
		}
		return hotels;
	},
	filterByRatingByMeal: function (hotels) {
		var filters = this.get('filterCriteria');
		if (filters.get('ratingMeal')) {
			hotels = _.filter(hotels, function (hotel) {
				var details = hotel.get('ratingDetails') ? hotel.get('ratingDetails').meal : null;
				return (details !== null) ? Math.round(details) >= filters.get('ratingMeal') : false;
			});
		}
		return hotels;
	}
});

export default SearchPageReviewsModel;